/* Copyright (c) 2018 Verge Technologies
 * @file index.js
 * @author Brenton Watt <brenton@verge.co.za>
 */

import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { split } from 'apollo-client-preset';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';

import { WebSocketLink } from 'apollo-link-ws';
import { getMainDefinition } from 'apollo-utilities';

import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';

import App from './App';

// let url = 'http://api.separations.verge.co.za';
// let wsUrl = 'ws://api.separations.verge.co.za';
// let port = '';

// Live details
let url = 'https://api.separations.co.za';
let wsUrl = 'wss://api.separations.co.za';
let port = '';

Modal.setAppElement(document.getElementById('root'));
if (localStorage.getItem('SEPARATIONS_FAVOURITES') === null) {
  localStorage.setItem('SEPARATIONS_FAVOURITES', JSON.stringify([]));
}

const httpLink = new HttpLink({ uri: `${url}:${port}/graphql` });

const middlewareAuthLink = setContext(() => ({
  headers: {
    authorization: localStorage.getItem('AUTH_TOKEN'),
  },
}));

const httpLinkWithAuthToken = middlewareAuthLink.concat(httpLink);

const wsLink = new WebSocketLink({
  uri: `${wsUrl}:${port}/subscriptions`,
  options: {
    reconnect: true,
    connectionParams: {
      authorization: localStorage.getItem('AUTH_TOKEN'),
    },
  },
});

const link = split(
  ({ query }) => {
    const mainDefinition = getMainDefinition((query));
    const { kind, operation } = mainDefinition;
    return kind === 'OperationDefinition' && operation === 'subscription';
  },
  wsLink,
  httpLinkWithAuthToken,
);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <App client={client} />
  </ApolloProvider>
  , document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js